import styled from 'styled-components';
import { gridSizes, media, weights } from 'utils/style';
import OrderDetailPrice from './OrderDetailPrice';

export default styled(OrderDetailPrice)`
  min-width: 300px;

  ${media.greaterThan('medium')`
    position: relative;
  `};

  padding: ${gridSizes('L')} 0;

  .total-container {
    display: flex;
    flex-direction: column;
  }

  h1 {
    font-size: ${gridSizes('L')};
    color: var(--grey900);
    font-weight: ${weights('medium')};
  }

  ${media.lessThan('medium')`
    width: 100%;
    position: initial;
    max-width: unset;
  `}

  .vat-value {
    font-size: ${gridSizes('M')};
    color: var(--grey700);
    font-weight: ${weights('regular')};
    margin: 0;
    text-align: right;

    ${media.lessThan('medium')`
    text-align: left;
  `};
  }
`;
